import styles from "./index.module.css";
import { ChevronRight } from "react-ikonate";
import classNames from "classnames";

/**
 * Takes an array of numbers and turns it into an array of tree-looking components as if by magic.
 */
export default function NestingMarkers({ nesting, expanded, onExpandToggle }) {
  return (
    <div className={styles.nestingMarkers}>
      {nesting.map((markerType, i) => {
        switch (markerType) {
          case 0:
            return <OuterChildMarker key={i} />;
          case 1:
            return (
              <LastChildMarker
                key={i}
                expanded={expanded}
                onExpandToggle={onExpandToggle}
              />
            );
          case 2:
            return <InnerChildMarker key={i} />;
          case 3:
            return (
              <MiddleChildMarker
                key={i}
                expanded={expanded}
                onExpandToggle={onExpandToggle}
              />
            );
          case undefined:
            return null;
          default:
            throw new Error(
              `Bad nesting array. Only 0, 1, 2, 3 and undefined are valid values. Got: ${markerType}`
            );
        }
      })}
    </div>
  );
}

/**
 * Type 0
 */
function OuterChildMarker() {
  return (
    <div
      className={classNames(styles.nestingMarker, styles.outerChildMarker)}
    />
  );
}

/**
 * Type 1
 */
function LastChildMarker({ expanded = false, onExpandToggle }) {
  return (
    <div className={classNames(styles.nestingMarker, styles.lastChildMarker)}>
      <div className={styles.childLine} />
      <button
        className={classNames(styles.expandToggle, {
          [styles.expanded]: expanded,
        })}
        onClick={onExpandToggle}
      >
        <ChevronRight />
      </button>
    </div>
  );
}

/**
 * Type 2
 */
function InnerChildMarker() {
  return (
    <div className={classNames(styles.nestingMarker, styles.innerChildMarker)}>
      <div className={styles.middleChildLine} />
    </div>
  );
}

/**
 * Type 3
 */
function MiddleChildMarker({ expanded = false, onExpandToggle }) {
  return (
    <div className={classNames(styles.nestingMarker, styles.middleChildMarker)}>
      <div className={styles.childLine} />
      <div className={styles.middleChildLine} />
      <button
        className={classNames(styles.expandToggle, {
          [styles.expanded]: expanded,
        })}
        onClick={onExpandToggle}
      >
        <ChevronRight />
      </button>
    </div>
  );
}
